export interface ChatBlockContext {
  readonly key: string;
  readonly disclosure: Map<string, boolean>;
}

/** Object fallback supports standalone renderers; threads supply durable keys. */
export class ChatBlockDisclosure {
  private local = new WeakMap<object, boolean>();
  private contexts = new WeakMap<object, ChatBlockContext>();
  bind(block: object, context?: ChatBlockContext): void {
    if (context) this.contexts.set(block, context);
  }
  get(block: object): boolean | undefined {
    const context = this.contexts.get(block);
    return context ? context.disclosure.get(context.key) : this.local.get(block);
  }
  set(block: object, expanded: boolean): void {
    const context = this.contexts.get(block);
    if (context) context.disclosure.set(context.key, expanded);
    else this.local.set(block, expanded);
  }
}
